
import UiYoutubePlayer from './UiYoutubePlayer.vue'

import Vue from 'vue'


class YoutubePlayer{
  constructor(){
    this.vueInstance=null;
  }

  // creating new modal with ok and cancel button
  load(youtubeId){

    return new Promise((resolve)=>{
      this.vueInstance= new Vue({
        render: h => h( UiYoutubePlayer,{
          props:{
            youtubeId:youtubeId
          },
          on:{
            close:() => { this.close(resolve)},
          }
        })
      }).$mount();
      document.body.appendChild(this.vueInstance.$el);

    });
  }


  // ok button clicked
  close(resolve){
    document.body.removeChild(this.vueInstance.$el);
    this.vueInstance=null;
    resolve();
  }


}

// exporting 'singleton' here
export let youtubePlayer = new YoutubePlayer();